import {
  APPEND_NOTIFICATIONS,
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
  NotificationActionsType,
  RESET_NOTIFICATIONS,
  SET_NOTIFICATIONS,
  SET_NOTIFICATION_COUNT
} from './actions';
import {INotificationActionHandler, INotificationInitialState, INotificationsResponse} from './interfaces';

const notificationInitialState: INotificationInitialState = {
  notifications: [],
  page: null,
  notificationCount: 0
};

const setNotificationsHandler = ({state, payload}: INotificationActionHandler): INotificationInitialState => {
  const response = payload as INotificationsResponse;

  return {
    ...state,
    notifications: response.data,
    page: response.page
  };
};

const appendNotificationsHandler = ({state, payload}: INotificationActionHandler): INotificationInitialState => {
  const response = payload as INotificationsResponse;

  return {
    ...state,
    notifications: [...state.notifications, ...response.data],
    page: response.page
  };
};

const markNotificationReadHandler = ({state, payload}: INotificationActionHandler): INotificationInitialState => {
  const notifId = payload as number;
  const wasUnread = state.notifications.some(n => n.id === notifId && !n.indRead);

  return {
    ...state,
    notifications: state.notifications.map(n => {
      return n.id === notifId
        ? {...n, indRead: true, activityNotifViewTime: new Date().toISOString(), status: 'executed'}
        : n;
    }),
    notificationCount: wasUnread ? Math.max(0, state.notificationCount - 1) : state.notificationCount
  };
};

const markAllNotificationsReadHandler = ({state}: INotificationActionHandler): INotificationInitialState => {
  return {
    ...state,
    notifications: state.notifications.map(n => ({...n, indRead: true})),
    notificationCount: 0
  };
};

const resetNotificationsHandler = ({state}: INotificationActionHandler): INotificationInitialState => {
  return {
    ...state,
    notifications: [],
    page: null
  };
};

function setNotificationCount({
  state,
  payload
}: INotificationActionHandler): INotificationInitialState {
  return {
    ...state,
    notificationCount: payload as number
  };
}

const notificationReducerHandlers = new Map([
  [SET_NOTIFICATIONS, setNotificationsHandler],
  [APPEND_NOTIFICATIONS, appendNotificationsHandler],
  [MARK_NOTIFICATION_READ, markNotificationReadHandler],
  [MARK_ALL_NOTIFICATIONS_READ, markAllNotificationsReadHandler],
  [RESET_NOTIFICATIONS, resetNotificationsHandler],
  [SET_NOTIFICATION_COUNT, setNotificationCount]
]);

const notificationReducer = (state = notificationInitialState, action: NotificationActionsType): INotificationInitialState => {
  const handler = notificationReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<INotificationActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default notificationReducer;
